var _desc, _defs, _rect, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "MailLens.AI Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "Rounded square with an envelope and a magnifying glass to indicate AI-powered email insights.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gml",
    x1: 64,
    y1: 64,
    x2: 448,
    y2: 448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10B981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B82F6"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "soft",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 8,
    stdDeviation: 12,
    floodOpacity: 0.25
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 32,
    width: 448,
    height: 448,
    rx: 96,
    fill: "url(#gml)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#soft)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 168,
    width: 288,
    height: 176,
    rx: 18,
    fill: "white",
    opacity: 0.98
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112 188l144 100 144-100",
    fill: "none",
    stroke: "#E5E7EB",
    strokeWidth: 14
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(308 300)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 42,
    fill: "none",
    stroke: "white",
    strokeWidth: 16,
    opacity: 0.95
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 28,
    width: 64,
    height: 18,
    rx: 9,
    transform: "rotate(45 28 28)",
    fill: "white",
    opacity: 0.95
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.778681dc508362de81f44c3e8b54fdc6.svg";
export { ForwardRef as ReactComponent };